import React from 'react';
import styled from 'styled-components';

import { toRem } from '@front/common/src/utils/styles';

import Button from '../button/button';

export const CLOSE_BUTTON_WRAPPER_HEIGHT = 69;

const CloseButtonWrapper = styled.div`
  display: flex;
  height: ${toRem(CLOSE_BUTTON_WRAPPER_HEIGHT)};
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding-top: ${toRem(10)};
  padding-bottom: ${toRem(10)};
  box-sizing: border-box;
`;

type CloseFooterProps = {
  close: () => void;
  closeText: string;
};

const CloseFooter = ({ close, closeText }: CloseFooterProps) => (
  <CloseButtonWrapper>
    <Button onPress={close}>{closeText}</Button>
  </CloseButtonWrapper>
);

export default CloseFooter;
